import type { TemplateLogoAlignment, TemplateLogoSize } from '@/templates/domain/types/TemplateLogo';
import { assertSafeImageUrl } from '@/common/domain/utils/assertSafeImageUrl';
import { logoImageStyle, logoSlotStyle } from '../application/logoLayout';

interface Props {
  url: string;
  size: TemplateLogoSize;
  alignment: TemplateLogoAlignment;
  /** When true, omit bottom margin (footer slot). */
  compact?: boolean;
  slot?: 'header' | 'footer' | 'cover' | 'fields';
}

/** Renders a company logo only when `url` is a safe non-empty image URL — no empty/broken box. */
export function CompanyLogoSlot({ url, size, alignment, compact = false, slot = 'header' }: Props) {
  const trimmed = assertSafeImageUrl(url);
  if (!trimmed) return null;

  const slotStyle = logoSlotStyle(alignment, size);
  if (compact || slot === 'footer') {
    slotStyle.marginBottom = 0;
    slotStyle.marginTop = size === 'large' ? 12 : 8;
  }

  return (
    <div style={slotStyle} data-testid={`document-render:logo:${slot}`} data-logo-alignment={alignment} data-logo-size={size}>
      <img src={trimmed} alt="Company logo" style={logoImageStyle(size)} />
    </div>
  );
}
